import api from './api';
import { IObjectState } from 'interfaces/applicant.interface';

const _resourceUrl = '/front';

export const getKpuState = (): Promise<{ objects: IObjectState[] }> => {
  return api.get(`${_resourceUrl}/kpu/state`);
};
